import { render, staticRenderFns } from "./orderBy.vue?vue&type=template&id=be264952&scoped=true&"
import script from "./orderBy.vue?vue&type=script&lang=js&"
export * from "./orderBy.vue?vue&type=script&lang=js&"
import style0 from "./orderBy.vue?vue&type=style&index=0&id=be264952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be264952",
  null
  
)

export default component.exports